var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoGrisClaro",attrs:{"id":"section6"}},[_c('tUnis',{attrs:{"titles":_vm.titles,"unis":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }